var serieses = [
	[
		'//www.youtube.com/embed/8y7DpwPKa9U?rel=0&amp;showinfo=0',
		'//www.youtube.com/embed/K1V8_e-DxAo?rel=0&amp;showinfo=0',
		'//www.youtube.com/embed/udTBGcNl0M8?rel=0&amp;showinfo=0',
		'//www.youtube.com/embed/4clvdCZL8gg?rel=0&amp;showinfo=0',
		'//www.youtube.com/embed/y0jfmYn23_o?rel=0&amp;showinfo=0',
		'//www.youtube.com/embed/7_NrDEm3iPU?rel=0&amp;showinfo=0'
	],
	[
		'//www.youtube.com/embed/RBI6-WtuTgk?rel=0&amp;showinfo=0',
		'//www.youtube.com/embed/RBI6-WtuTgk?rel=0&amp;showinfo=0',
		'//www.youtube.com/embed/t8SjxHoSAAI?rel=0&amp;showinfo=0'
	],
	[]
]

document.querySelectorAll('[am-page="series"] .pagination li a').forEach(function (el) {
	el.addEventListener('click', function (event) {
		document.querySelectorAll('[am-page="series"] .pagination li').forEach(function (el) {
			el.classList.remove('active')
		})
		el.parentNode.classList.add('active')
		var seriesID = parseInt(document.querySelector('[name="series"]').value, 10) - 1
		var vidID = parseInt(el.textContent, 10) - 1
		if (typeof serieses[seriesID][vidID] !== 'undefined') {
			document.querySelector('[am-page="series"] .videoWrapper').innerHTML = '<iframe width="560" height="315" frameborder="0" allowfullscreen="" src="' + serieses[seriesID][vidID] + '"></iframe>'
		}
		if (event.preventDefault) {
			event.preventDefault()
		}
		else {
			event.returnValue = false
		}
		return false
	})
})
document.querySelector('[name="series"]').addEventListener('change', function () {
	// setImmediate(clickOnNumber1ToGetFirstVideoInSeries())
	setTimeout(function () {
		document.querySelector('[am-page="series"] .pagination li a').click()
	}, 0)
})
